import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { I18NextModule } from 'angular-i18next';
import { RouteTranslatePipe } from '../../pipes/route-translate.pipe';

@Component({
  selector: 'sharry-gift-card-banner',
  standalone: true,
  imports: [I18NextModule, MatButtonModule, RouteTranslatePipe, RouterLink, NgClass],
  templateUrl: './gift-card-banner.component.html',
  styleUrl: './gift-card-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GiftCardBannerComponent {
  @Input() bottomSpacing: boolean = false;
  @Input() topSpacing: boolean = false;
}
